module.exports = __webpack_public_path__ + "static/vuplex-logo-4253cfce45facbb3c957cb94b83fd7d6.png";